<template>
    <svg
        class="kkmail"
        width="19px"
        height="17px"
        viewBox="0 0 19 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Symbols"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
        >
            <g
                id="btn_icon_normal"
                transform="translate(-40.000000, -21.000000)"
                :fill="color"
            >
                <g id="Group-3">
                    <g id="Group-4" transform="translate(40.000000, 21.000000)">
                        <polygon
                            id="Path-4"
                            points="7 11 0 9 19 0 19 16 12 13 9.5 17 9.5 12 16 4"
                        ></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'kk-mail',
    props: {
        color: {
            type: String,
            default: '#2960e8',
        },
    },
};
</script>
